/*! angular-neat-table - v1.0.0 - 
 (c) Valentin Hervieu <valentin@hervi.eu> - 
 git+ssh://git@gitlab.com/ValentinH/angular-neat-table.git - 
 2017-10-12 */
'use strict';

(function (angular) {
  NeatTable.$inject = ['$scope'];
  var module = angular.module('neatTableModule', ['vs-repeat', 'ui.bootstrap']);

  module.directive('neatTable', function () {
    return {
      restrict: 'EA',
      templateUrl: 'angular-neat-table.html',
      scope: {
        columnHeadings: '=',
        rowsData: '=',
        onElementUpdate: '&?',
        tableId: '@?'
      },
      controller: NeatTable,
      controllerAs: 'vm',
      bindToController: true
    };
  });

  function NeatTable($scope) {
    var vm = this;
    vm.showScrollbarPlaceholder = false;

    if (!vm.onElementUpdate) {
      vm.onElementUpdate = function () {

      };
    }

    vm.activate = function () {
      vm.scrollBarSize = vm.getScrollbarSize();
      if (vm.scrollBarSize > 0) {
        vm.showScrollbarPlaceholder = true;
      }
    };

    vm.checkboxChange = function (row) {
      vm.onElementUpdate({rowId: row.rowID, rowState: row.Cells});
    };

    vm.radioChange = function (row, $index) {
      // ensure that only one radio is checked
      for (var i = 0; i < row.Cells.length; i++) {
        row.Cells[i] = i === $index ? 1 : 0;
      }
      vm.onElementUpdate({rowId: row.rowID, rowState: row.Cells});
    };

    vm.getScrollbarSize = function () {
      var outer = document.createElement("div");
      outer.style.visibility = "hidden";
      outer.style.width = "100px";
      outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

      document.body.appendChild(outer);

      var widthNoScroll = outer.offsetWidth;
      // force scrollbars
      outer.style.overflow = "scroll";

      // add innerdiv
      var inner = document.createElement("div");
      inner.style.width = "100%";
      outer.appendChild(inner);

      var widthWithScroll = inner.offsetWidth;

      // remove divs
      outer.parentNode.removeChild(outer);

      return widthNoScroll - widthWithScroll;
    };

    $scope.$on("NeatTable:HeaderHeight", function (event, args) {
      if (args.value) {
        vm.headerHeight = args.value;
      }
    });

    vm.activate();
  }

  module.directive('emHeightSource', function () {
    return {
      restrict: 'A',
      link: function (scope, elem) {

        scope.$watch(function () {
            return elem.height();
          }, function () {
            var headerHeight = elem.height();
            scope.$emit("NeatTable:HeaderHeight", {
              "value": headerHeight
            });
          }
        );
      }
    };
  });

  module.directive('syncScroll', ['$document', function ($document) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var rowsHeader = null,
          colsHeader = null,
          jElement = $(element);

        scope.startPosition = 0;
        scope.startScroll = 0;
        scope.currentDirection = null;

        scope.activate = function () {
          rowsHeader = $(attrs.rowsHeader);
          if (!rowsHeader.length) {
            throw new Error(
              "neatTable: syncScroll rowsHeader selector \"" +
              attrs.rowsHeader +
              "\" doesn't match any element");
          }

          colsHeader = $(attrs.colsHeader);
          if (!colsHeader.length) {
            throw new Error(
              "neatTable: syncScroll colsHeader selector \"" +
              attrs.colsHeader +
              "\" doesn't match any element");
          }

          element.on('scroll', scope.onElementScroll);
          rowsHeader.on('mousewheel wheel', scope.onRowHeaderScroll);
          colsHeader.on('mousewheel wheel', scope.onColHeaderScroll);

          rowsHeader.on('touchstart', function (e) {
            scope.onHeaderTouch(e, 'Y');
          });
          colsHeader.on('touchstart', function (e) {
            scope.onHeaderTouch(e, 'X');
          });
        };

        scope.onElementScroll = function () {
          var leftOffset = jElement.scrollLeft(),
            topOffset = jElement.scrollTop();
          rowsHeader.scrollTop(topOffset);
          colsHeader.scrollLeft(leftOffset);
        };

        scope.onRowHeaderScroll = function (e) {
          e.preventDefault();
          var topOffset = jElement.scrollTop(),
            delta = e.originalEvent.wheelDeltaY;
          if (typeof delta === "undefined") {
            // for firefox
            delta = -e.originalEvent.deltaY;
          }
          jElement.scrollTop(topOffset - delta);
        };

        scope.onColHeaderScroll = function (e) {
          e.preventDefault();
          var topOffset = jElement.scrollLeft(),
            delta = e.originalEvent.wheelDeltaX;
          if (typeof delta === "undefined") {
            // for firefox
            delta = -e.originalEvent.deltaX;
          }
          jElement.scrollLeft(topOffset - delta);
        };

        scope.onHeaderTouch = function (event, direction) {
          event.preventDefault();
          if (!event.targetTouches) {
            // to handle old devices
            event = event.originalEvent;
          }

          if (event.targetTouches.length > 0) {
            scope.startPosition = event.targetTouches[0]['page' + direction];
            scope.currentDirection = direction;
            scope.startScroll = direction === 'X' ? jElement.scrollLeft() : jElement.scrollTop();
            $document.on('touchmove', scope.touchMove);
            $document.on('touchend', scope.touchEnd);
          }
        };

        scope.touchMove = function (event) {
          if (!event.targetTouches) {
            // to handle old devices
            event = event.originalEvent;
          }

          var direction = scope.currentDirection;
          if (event.targetTouches.length > 0) {
            var newPosition = event.targetTouches[0]['page' + direction],
              offset = scope.startPosition - newPosition,
              newScroll = scope.startScroll + offset;

            if (scope.currentDirection === 'X') {
              jElement.scrollLeft(newScroll);
            }
            else if (scope.currentDirection === 'Y') {
              jElement.scrollTop(newScroll);
            }
          }
        };

        scope.touchEnd = function () {
          $document.off('touchmove', scope.touchMove);
          $document.off('touchend', scope.touchEnd);
          scope.direction = null;
        };

        scope.$on('$destroy', function () {
          $document.off('touchmove', scope.touchMove);
          $document.off('touchend', scope.touchEnd);
        });

        setTimeout(function () {
          scope.$apply();
          scope.activate();
        }, 0);
      }
    };
  }]);

  module.run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('angular-neat-table.html',
    "<div class=neat-table style='max-height: 100%;' ng-style=\"{height: (vm.rowsData.length*25 + vm.headerHeight + 20) +'px'}\"><div" +
    " class=left-part><div class=header-row" +
    " ng-style=\"{height: vm.headerHeight}\"><div class=header-item>Node</div></div><div id=row-headers-{{vm.tableId}} class=table-content><div class=neat-row ng-class=\"{even: row.index % 2 === 0, 'neat-clickable': row.RowHeaderTooltip}\" ng-repeat=\"row in vm.rowsData track by row.rowID\" uib-tooltip=\"{{ row.RowHeaderTooltip }}\" tooltip-trigger=outsideClick tooltip-placement=top-left style={{row.style}}><div class=neat-item><i ng-if=row.readonly class=\"fa fa-lock\" style=\"margin-right: 3px\"></i>{{ row.RowHeader }}</div></div><div class=\"neat-row scrollbar-placeholder\" ng-if=vm.showScrollbarPlaceholder ng-style=\"{height: vm.scrollBarSize+'px'}\"></div></div></div><div class=right-part><div em-height-source id=columns-header-{{vm.tableId}} class=\"header-row neat-row\"><div class=neat-item ng-repeat=\"col in vm.columnHeadings\">{{ col }}</div><div class=\"neat-item scrollbar-placeholder\" style=\"border: none\" ng-if=vm.showScrollbarPlaceholder ng-style=\"{width: vm.scrollBarSize+'px'}\"></div></div><div class=table-content vs-repeat sync-scroll rows-header=#row-headers-{{vm.tableId}} cols-header=#columns-header-{{vm.tableId}}><div class=neat-row ng-class=\"{even: row.index % 2 === 0}\" ng-repeat=\"row in vm.rowsData track by row.rowID\" style={{row.style}}><div class=neat-item ng-repeat=\"val in row.Cells track by $index\"><label ng-if=\"row.type === 'CHECKBOX'\" class=\"neat-control neat-control-checkbox\"><input type=checkbox ng-model=row.Cells[$index] ng-change=vm.checkboxChange(row) ng-true-value=1 ng-false-value=0 ng-disabled=\"!row.enabled\"><div class=neat-control-indicator></div></label><label ng-if=\"row.type === 'RADIO'\" class=\"neat-control neat-control-radio\"><input type=radio ng-model=row.Cells[$index] ng-change=\"vm.radioChange(row, $index)\" ng-value=1 ng-disabled=\"!row.enabled\"><div class=neat-control-indicator></div></label><div ng-if=\"row.type === 'PLAIN_TEXT'\">{{val}}</div><div ng-if=\"row.type === 'STYLE_TEXT'\" style={{val.style}} title={{val.fulltext}}>{{val.displayText}}</div></div></div></div></div></div>"
  );

}]);
})(window.angular);



// WEBPACK FOOTER //
// ./app/lib/angular-neat-table/angular-neat-table.js